import React from 'react';
import { Result, Button } from 'antd';
import { HomeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

const NotFoundPage = () => {
  const history = useHistory();

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100%',
    backgroundColor: '#f0f2f5', // Standard AntD v4 background color
  };

  return (
    <div style={containerStyle}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={[
          <Button 
            key="back" 
            icon={<ArrowLeftOutlined />} 
            onClick={() => history.goBack()}
          >
            Go Back
          </Button>,
          <Button 
            key="home" 
            type="primary" 
            icon={<HomeOutlined />} 
            onClick={() => history.push('/')}
          >
            Back Home
          </Button>,
        ]}
      />
    </div>
  );
};

export default NotFoundPage;